'use client'

import { MantineProvider } from '@mantine/core'
import { mercyTheme } from '@/tenants/mercy/theme/mercyTheme'
import { mercyCssResolver } from '@/tenants/mercy/theme/mercyCssResolver'
import './mercyGlobal.css'

// Output resolved CSS tokens on tenant-specific selector instead of the default :root. The higher specificity ensures that
// tokens at the :root level will always be overridden.
const MERCY_ROOT = ":root[data-tenant='mercy']"

export default function MercyThemeProvider({ children }: { children: React.ReactNode }) {
    return (
        <MantineProvider theme={mercyTheme} cssVariablesResolver={mercyCssResolver} cssVariablesSelector={MERCY_ROOT}>
            {children}
        </MantineProvider>
    )
}
